import { useState } from "react";
import useAuthHttp from "./useAuthHttp";

export interface IVehicleModelResult {
    vehicle_model_list: IVehicleModelList[]
}
  
export interface IVehicleModelList {
    id: string
    vehicle_model_label: string
    vehicle_model_value: number
    years: IVehicleModelYear[]
    brand: IVehicleModelBrand
}
  
export interface IVehicleModelYear {
    mdl_year_label: string
    mdl_year_value: string
}
  
export interface IVehicleModelBrand {
    vehicle_model_brand_label: string
    vehicle_model_brand_value: string
}

export interface IVehicleModel {
    id: string;
    name: string;
    value: number;
    years: IVehicleModelYear[];
}

export const useFindVehicleModel = () => {
    const { doGet } = useAuthHttp();
    const [vehicleModelsSearch, setVehicleModelsSearch] = useState<IVehicleModel[]>([]);
    const [loadingVehicleModels, setLoadingVehicleModels] = useState(false);
    
    const findVehicleModelByBrandCodeAndName = async (code: string, name: string): Promise<void> => {
        setLoadingVehicleModels(true);

        try {
            if (!name) {
                setVehicleModelsSearch([]);
                return;
            }

            const result = await doGet<IVehicleModelResult>(`/vehicle/model/list?code=${code}&label=${name}`);
    
            setVehicleModelsSearch(result?.vehicle_model_list?.map(v => 
                ({ id: v.id, name: v.vehicle_model_label, value: v.vehicle_model_value, years: v.years })) ?? []);
        } finally {
            setTimeout(() => {
                setLoadingVehicleModels(false);
            }, 1000);
        }
    }

    return { 
        findVehicleModelByBrandCodeAndName, 
        vehicleModelsSearch, 
        setVehicleModelsSearch, 
        loadingVehicleModels 
    };
}
